/* GLLF Grow guide v2 — tabs, format-aware arrival notes, season highlight, zone check, zone ruler and a
   "your year" planting calendar. Reads the shared zone keys used across the site and saves the same way
   Smart Shop does. Writes no store data. */
(function () {
  'use strict';
  var ZONE_KEYS = ['gllf_hardiness_zone', 'gllf_usda_zone', 'gllf_zone', 'hardinessZone', 'gllf_destination_v1'];
  var EVENTS = ['gllf:zoneUpdated', 'gllf:zone-change', 'gllf:zone-changed', 'gllf:hardiness-zone-change', 'gllf-zone-updated', 'hardinessZoneChanged'];
  // Typical average frost dates by whole USDA zone [month(1-12), day]. 'b' zones shift a week milder.
  var FROST = { 3: [[5, 25], [9, 15]], 4: [[5, 15], [9, 25]], 5: [[5, 5], [10, 5]], 6: [[4, 22], [10, 18]], 7: [[4, 8], [10, 30]], 8: [[3, 22], [11, 12]], 9: [[2, 25], [12, 5]] };
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var FULL = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(v) { var m = String(v == null ? '' : v).toLowerCase().match(/(?:^|[^0-9])((?:1[0-3]|[1-9])[ab])(?![0-9])/); return m ? m[1] : ''; }
  function zNum(z) { var m = String(z || '').match(/^(\d+)([ab])$/); return m ? parseInt(m[1], 10) + (m[2] === 'b' ? 0.5 : 0) : null; }
  function zLabel(n) { return Math.floor(n) + (n % 1 ? 'b' : 'a'); }
  function read(key) { try { var v = localStorage.getItem(key); if (!v) return null; try { return JSON.parse(v); } catch (e) { return v; } } catch (e) { return null; } }
  function storedZone() {
    for (var i = 0; i < ZONE_KEYS.length; i++) {
      var r = read(ZONE_KEYS[i]); if (!r) continue;
      var z = norm(typeof r === 'object' ? (r.zone || r.hardinessZone || r.usdaZone || r.value) : r);
      if (z) return z;
    }
    return '';
  }
  function saveZone(zone, zip, source) {
    var p = { zone: zone, hardinessZone: zone, zip: zip || '', source: source || 'grow-guide', updatedAt: Date.now() };
    try { localStorage.setItem('gllf_hardiness_zone', JSON.stringify(p)); localStorage.setItem('gllf_usda_zone', JSON.stringify(p)); localStorage.setItem('gllf_zone', zone); localStorage.setItem('hardinessZone', zone); } catch (e) {}
    EVENTS.forEach(function (n) { try { document.dispatchEvent(new CustomEvent(n, { detail: p })); window.dispatchEvent(new CustomEvent(n, { detail: p })); } catch (e) {} });
  }
  function date(md, add) { var d = new Date(new Date().getFullYear(), md[0] - 1, md[1]); d.setDate(d.getDate() + (add || 0)); return d; }
  function fmt(d) { return MON[d.getMonth()] + ' ' + d.getDate(); }
  function mpos(d) { return d.getMonth() + (d.getDate() - 1) / 30.5; } // 0..12 position on the year track
  function month(v) {
    var s = String(v || '').toLowerCase(); if (!s) return null;
    var m = -1; FULL.forEach(function (f, i) { if (m < 0 && s.indexOf(f) >= 0) m = i; });
    if (m < 0) return null;
    return m + (/early/.test(s) ? 0.1 : /late/.test(s) ? 0.7 : 0.4);
  }

  /* planting windows: returns text rows + bands for the year chart */
  function plan(n, f, lav) {
    var whole = Math.floor(n), half = n % 1 ? 7 : 0, rows = [], bands = [];
    if (whole >= 10) {
      rows.push(['Best time to plant', 'Fall through late winter', 'Your zone rarely freezes. Plant in the cool season and avoid planting into summer heat.']);
      bands.push(['plant', 9.5, 12], ['plant', 0, 2]);
      return { rows: rows, bands: bands, frost: 'Frost is rare in your zone.' };
    }
    var fr = FROST[Math.max(3, whole)] || FROST[3];
    var lf = date(fr[0], -half), ff = date(fr[1], half), a, b;
    bands.push(['frost', 0, mpos(lf)], ['frost', mpos(ff), 12]);
    if (f === 'bare') {
      a = date(fr[0], -28 - half); b = date(fr[0], 21 - half);
      rows.push(['Plant your bare root', fmt(a) + ' – ' + fmt(b), 'As soon as the soil can be worked. A light frost won’t hurt a dormant plant, but don’t plant into frozen or soggy ground.']);
      rows.push(['If it arrives early', 'Pot it up', 'Pot it in a 1–2 gallon pot and keep it cool (35–45°F) and barely moist until your window opens.']);
      bands.push(['plant', mpos(a), mpos(b)]);
    } else {
      a = date(fr[0], (lav ? 7 : 0) - half); b = date(fr[0], (lav ? 56 : 60) - half);
      rows.push(['Spring planting', fmt(a) + ' – ' + fmt(b), lav ? 'After your last frost, once nights stay above 40°F. Earlier is better — roots need summer to settle in.' : 'After your last frost date, once the soil is workable and warming.']);
      bands.push(['plant', mpos(a), mpos(b)]);
      if (lav && whole <= 6) {
        rows.push(['Fall planting', 'Skip it in your zone', 'Lavender planted in fall often fails to root before winter here. Plant by mid-summer, or keep it potted in an unheated garage until spring.', 'skip']);
      } else {
        a = date(fr[1], -70 + half); b = date(fr[1], (lav ? -49 : -42) + half);
        rows.push(['Fall planting', fmt(a) + ' – ' + fmt(b), 'At least 6 weeks before your first frost so roots settle in before the ground freezes.']);
        bands.push(['fall', mpos(a), mpos(b)]);
      }
    }
    return { rows: rows, bands: bands, frost: 'Typical last frost about ' + fmt(lf) + ' · first frost about ' + fmt(ff) + '. Local dates can differ by a couple of weeks.' };
  }

  function init(root) {
    if (root.dataset.ggReady) return; root.dataset.ggReady = '1';
    var d; try { d = JSON.parse(root.querySelector('[data-gg-data]').textContent); } catch (e) { d = {}; }
    var fmtNow = (d.variants || {})[String(d.first)] || '';

    /* tabs */
    var tabs = [].slice.call(root.querySelectorAll('[role=tab]'));
    function pick(t, focus) {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = k === 'ArrowRight' ? i + 1 : k === 'ArrowLeft' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? tabs.length - 1 : null;
        if (j == null) return; e.preventDefault(); pick(tabs[(j + tabs.length) % tabs.length], true);
      });
    });

    /* season highlight */
    var mo = new Date().getMonth(), season = mo < 2 || mo === 11 ? 'winter' : mo < 5 ? 'spring' : mo < 8 ? 'summer' : 'fall';
    var sEl = root.querySelector('[data-season="' + season + '"]'); if (sEl) sEl.classList.add('now');

    /* zone tool */
    var out = root.querySelector('[data-gg-out]'), status = root.querySelector('[data-gg-status]'), sel = root.querySelector('[data-gg-zsel]'), fact = root.querySelector('[data-gg-fact-zone]');
    var you = root.querySelector('[data-gg-you]'), year = root.querySelector('[data-gg-year]'), track = root.querySelector('[data-gg-year-track]'), key = root.querySelector('[data-gg-year-key]');
    var baseOut = out ? out.innerHTML : '';
    function pct(x) { return (Math.max(0, Math.min(12, x)) / 12 * 100).toFixed(2) + '%'; }
    function drawYear(p) {
      if (!year || !track) return;
      var html = '', has = {};
      p.bands.forEach(function (b) { if (b[2] <= b[1]) return; has[b[0]] = 1; html += '<span class="gg-yb gg-yb--' + b[0] + '" style="left:' + pct(b[1]) + ';width:' + ((b[2] - b[1]) / 12 * 100).toFixed(2) + '%"></span>'; });
      var s0 = month(d.bloomStart), pk = month(d.bloomPeak);
      if (s0 != null || pk != null) {
        if (s0 == null) s0 = Math.max(0, pk - 0.7); if (pk == null) pk = s0 + 0.7;
        html += '<span class="gg-yb gg-yb--bloom" style="left:' + pct(s0) + ';width:' + ((Math.min(12, pk + 0.9) - s0) / 12 * 100).toFixed(2) + '%"></span>'; has.bloom = 1;
      }
      var now = new Date(); html += '<span class="gg-yb gg-yb--now" style="left:' + pct(mpos(now)) + '" title="Today"></span>';
      track.innerHTML = html;
      var k = [['plant', '#6fae5f', 'Best planting window'], ['fall', '#a8cf8f', 'Fall planting'], ['bloom', '#7d66b0', 'Typical bloom'], ['frost', '#b9d4ef', 'Frost season']].filter(function (x) { return has[x[0]]; });
      k.push(['now', '#c99a3f', 'Today']);
      key.innerHTML = k.map(function (x) { return '<span><i style="background:' + x[1] + '"></i>' + x[2] + '</span>'; }).join('');
      year.hidden = false;
    }
    function renderZone() {
      if (!out) return;
      var z = storedZone(), n = zNum(z);
      if (sel) sel.value = z || '';
      if (n == null) { out.innerHTML = baseOut; if (fact) { fact.textContent = 'Hardiness'; fact.className = ''; } if (you) you.hidden = true; if (year) year.hidden = true; return; }
      if (you) { you.hidden = false; you.style.left = ((Math.min(Math.max(n, 3), 11.5) + 0.25 - 3) / 9 * 100).toFixed(2) + '%'; you.setAttribute('data-label', 'You: ' + z.toUpperCase()); }
      var html = '', cls = 'ok', icon = '✓', head, body = '';
      if (d.zmin != null) {
        var range = zLabel(d.zmin) + '–' + zLabel(d.zmax);
        if (n >= d.zmin && n <= d.zmax) { head = 'A good fit for zone ' + z.toUpperCase(); body = 'It’s rated for zones ' + range + '.'; }
        else if (n < d.zmin) {
          cls = n >= d.zmin - 0.5 ? 'edge' : 'no'; icon = cls === 'edge' ? '!' : '×';
          head = cls === 'edge' ? 'Borderline in zone ' + z.toUpperCase() : 'Zone ' + z.toUpperCase() + ' is colder than its range';
          body = 'It’s rated for zones ' + range + '. ' + (cls === 'edge' ? 'Give it your warmest, best-drained spot and a sheltered site.' : (d.container !== 'no' ? 'Grow it in a pot and move it to an unheated garage for winter.' : 'It’s unlikely to survive winter outdoors where you are.'));
        } else {
          cls = n <= d.zmax + 0.5 ? 'edge' : 'no'; icon = cls === 'edge' ? '!' : '×';
          head = cls === 'edge' ? 'Borderline in zone ' + z.toUpperCase() : 'Zone ' + z.toUpperCase() + ' is warmer than its range';
          body = 'It’s rated for zones ' + range + '. It may not get enough winter cold, or may struggle in long, humid heat.';
        }
        html += '<div class="gg-verdict ' + cls + '"><b aria-hidden="true">' + icon + '</b><div><p class="gg-big">' + esc(head) + '</p><p>' + esc(body) + '</p></div></div>';
        if (fact) { fact.textContent = cls === 'ok' ? '✓ Fits your zone ' + z.toUpperCase() : (cls === 'edge' ? 'Borderline for ' : 'Outside ') + 'zone ' + z.toUpperCase(); fact.className = cls === 'ok' ? 'ok' : 'no'; }
      } else {
        html += '<p class="gg-big">Your zone: ' + esc(z.toUpperCase()) + '</p>';
      }
      var p = plan(n, fmtNow, !!d.lavender);
      html += '<div class="gg-windows">' + p.rows.map(function (x) { return '<div class="gg-window' + (x[3] ? ' ' + x[3] : '') + '"><strong>' + esc(x[0]) + ': ' + esc(x[1]) + '</strong><span>' + esc(x[2]) + '</span></div>'; }).join('') + '</div>';
      html += '<p class="gg-frost">' + esc(p.frost) + ' <a class="gg-link" href="/pages/frost-date-estimator">Find your exact dates</a></p>';
      out.innerHTML = html;
      drawYear(p);
    }

    /* format-aware arrival + pot-up path */
    function showFormat(f) {
      if (!f) return; fmtNow = f;
      ['.gg-arrivals', '[data-gg-path]'].forEach(function (s) {
        var box = root.querySelector(s); if (!box) return;
        var items = box.querySelectorAll('[data-gg-fmt]'); if (items.length < 2) return;
        var any = false; items.forEach(function (it) { var on = it.dataset.ggFmt === f; it.classList.toggle('on', on); any = any || on; });
        box.classList.toggle('one', any);
      });
      renderZone();
    }
    function currentVariant() {
      var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = inp && inp.value; if (!id) { var m = location.search.match(/[?&]variant=(\d+)/); id = m && m[1]; }
      return id ? (d.variants || {})[String(id)] : '';
    }
    var sync = function () { setTimeout(function () { showFormat(currentVariant() || fmtNow); }, 60); };
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, .product-form, .product__info-container')) sync(); });
    ['variant:change', 'variant:changed', 'on:variant:change'].forEach(function (n) { document.addEventListener(n, sync); });
    showFormat(currentVariant() || fmtNow);

    var form = root.querySelector('[data-gg-zip]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = (form.zip.value || '').trim();
      if (!/^\d{5}$/.test(zip)) { status.textContent = 'Enter a five-digit U.S. ZIP code.'; form.zip.focus(); return; }
      status.textContent = 'Looking up your zone…';
      var urls = [d.zoneApi + '?zip=' + encodeURIComponent(zip), d.zoneTable];
      (function next(i) {
        if (i >= urls.length || !urls[i]) { status.textContent = 'Zone lookup isn’t available right now. Pick your zone from the list instead.'; return; }
        fetch(urls[i], { headers: { accept: 'application/json' } }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) {
          var z = norm(i === 1 ? j[zip] : (j.zone || j.hardinessZone || j.value));
          if (!z) throw 0;
          saveZone(z, zip, 'grow-guide');
          status.textContent = 'ZIP ' + zip + ' is in zone ' + z.toUpperCase() + '.';
          renderZone();
        }).catch(function () { next(i + 1); });
      })(0);
    });
    if (sel) sel.addEventListener('change', function () { if (sel.value) { saveZone(sel.value, '', 'grow-guide'); status.textContent = ''; renderZone(); } });
    EVENTS.forEach(function (n) { document.addEventListener(n, function (e) { if (!e.detail || e.detail.source !== 'grow-guide') renderZone(); }); });
    window.addEventListener('storage', renderZone);
    renderZone();
    /* warm up the art in hidden tabs once the page is idle, so tabs open instantly */
    var warm = function () { root.querySelectorAll('[role=tabpanel][hidden] img[loading=lazy]').forEach(function (i) { i.loading = 'eager'; }); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 2500);
  }
  function boot() { document.querySelectorAll('[data-gg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.GLLFGrowGuide = { boot: boot };
})();
